import { motion } from "framer-motion";
import PixelImage from "@/components/PixelImage";
import { PROJECTS } from "@/data/site";

const reveal = {
    hidden: { opacity: 0, y: 60 },
    show: (i) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 1, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.12 },
    }),
};

function ProjectCard({ project, i }) {
    return (
        <motion.article
            data-testid={`project-card-${project.id}`}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className={`group relative overflow-hidden border border-white/5 bg-[#0a0a0c] ${project.span}`}
        >
            <div className={`relative ${project.aspect} overflow-hidden bg-[#0a0a0c]`}>
                <PixelImage
                    src={project.image}
                    alt={project.title}
                    fit={project.fit}
                    duration={1300}
                    maxPixel={48}
                    className={`h-full w-full transition-all duration-700 ease-out group-hover:scale-[1.04] ${
                        project.fit === "contain"
                            ? "saturate-[0.8] group-hover:saturate-100"
                            : "saturate-[0.65] contrast-110 group-hover:saturate-100"
                    }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 via-transparent to-transparent pointer-events-none" />
                <span className="absolute top-4 left-4 font-mono-x text-[10px] tracking-[0.3em] text-neutral-400">
                    {String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute top-4 right-4 font-mono-x text-[9px] tracking-[0.3em] text-[#FF3333] border border-[#FF3333]/40 px-2 py-1 bg-black/40 backdrop-blur-sm">
                    {project.status}
                </span>
            </div>
            <div className="p-5 sm:p-6">
                <h3 className="font-display text-lg sm:text-2xl font-bold uppercase tracking-tight leading-tight group-hover:text-[#FF3333] transition-colors duration-300">
                    {project.title}
                </h3>
                <p className="font-mono-x text-[9px] sm:text-[10px] tracking-[0.25em] text-neutral-500 mt-2">
                    {project.meta}
                </p>
            </div>
        </motion.article>
    );
}

export default function Projects() {
    const rowA = PROJECTS.slice(0, 2);
    const rowB = PROJECTS.slice(2, 5);
    const rowC = PROJECTS.slice(5);

    return (
        <section id="work" data-testid="projects-section" className="relative px-5 sm:px-10 py-24 sm:py-36">
            <div className="mb-14 sm:mb-20 flex flex-col gap-4">
                <p className="font-mono-x text-[10px] sm:text-xs tracking-[0.4em] text-[#FF3333]">
                    SELECTED WORK 2024 - 2026
                </p>
                <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase tracking-tighter leading-[0.9]">
                    Recent <span className="text-outline">Shots</span>
                </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-5 sm:gap-6">
                {rowA.map((p, i) => (
                    <ProjectCard key={p.id} project={p} i={i} />
                ))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-5 sm:gap-6 mt-5 sm:mt-6">
                {rowB.map((p, i) => (
                    <ProjectCard key={p.id} project={p} i={i + 2} />
                ))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-5 sm:gap-6 mt-5 sm:mt-6">
                {rowC.map((p, i) => (
                    <ProjectCard key={p.id} project={p} i={i + 5} />
                ))}
                <motion.article
                    data-testid="project-card-scary-movie-6"
                    custom={6}
                    variants={reveal}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-80px" }}
                    className="group relative overflow-hidden border border-[#FF3333]/25 bg-[#0a0a0c] md:col-span-5"
                >
                    <div className="relative aspect-[16/10] overflow-hidden bg-[#0a0a0c]">
                        <PixelImage
                            src="/images/scary-movie-6.jpg"
                            alt="Scary Movie 6 official poster"
                            fit="contain"
                            duration={1300}
                            maxPixel={48}
                            className="h-full w-full saturate-[0.85] transition-all duration-700 group-hover:scale-[1.04] group-hover:saturate-100"
                        />
                        <span className="absolute top-4 right-4 font-mono-x text-[9px] tracking-[0.3em] text-[#FF3333] border border-[#FF3333]/40 px-2 py-1 bg-black/60 backdrop-blur-sm">
                            IN THEATRES JUNE 5
                        </span>
                    </div>
                    <div className="p-5 sm:p-6">
                        <h3 className="font-display text-lg sm:text-2xl font-bold uppercase tracking-tight leading-tight group-hover:text-[#FF3333] transition-colors duration-300">
                            SCARY MOVIE 6
                        </h3>
                        <p className="font-mono-x text-[9px] sm:text-[10px] tracking-[0.25em] text-neutral-500 mt-2">
                            FEATURED SHOTS - 2026 REEL
                        </p>
                    </div>
                    <span className="absolute top-4 left-4 font-mono-x text-[10px] tracking-[0.3em] text-neutral-400">06</span>
                </motion.article>
            </div>
        </section>
    );
}
